import {
  EMPTY,
  of as observableOf,
  Observable,
  Subscribable,
  PartialObserver,
  Subscriber,
  Subscription,
  asapScheduler,
  Observer
} from 'rxjs';

/*
  https://www.learnrxjs.io/operators/transformation/mergemap.html

  https://www.learnrxjs.io/operators/transformation/map.html

*/
import { map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  ActivatedRoute,
  NavigationEnd,
  RouterEvent
} from '@angular/router';
import { filter } from 'rxjs/operators';

import { TabNavEvent } from '@oa/shared-core';

/**
 * Navigating Event Data Interface
 */
interface NavigatingEventData {
  navigating: boolean;
  segments: string[];
}

@Injectable()
export class NavigationService {
  private readonly _serviceName = 'NavigationService';
  
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    console.log(`${this._serviceName}.ngOnInit()`);

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.navigating = this.router.events.pipe(
      mergeMap(event => {
        console.log(`${this._serviceName}.router.events.pipe event=`, event);

        return !(event instanceof RouteConfigLoadStart || event instanceof RouteConfigLoadEnd) ? observableOf(event) : EMPTY;
      }),
      map(event => {
        if (event instanceof RouteConfigLoadStart) {
          const routerEvent = event as RouterEvent;

          const item = {
            navigating: false,
            segments: routerEvent.url ? routerEvent.url.split('/') : []
          } as NavigatingEventData;

          return item;
        }

        return null;
      }),
      map(routingData => {
        return (routingData.navigating && routingData.segments[routingData.segments.length - 1]) || false;
      })
    );
  }

  get navigating$() {
    return this.navigating;
  }

  subscribe(observer: PartialObserver<TabNavEvent>) {
    const subscriber = new Subscriber();
    if (observer.next) subscriber.next = observer.next;
    if (observer.error) subscriber.error = observer.error;
    if (observer.complete) subscriber.complete = observer.complete;
    
    this.subscribers.push(subscriber);
    return new Subscription(() => {
      const index = this.subscribers.indexOf(subscriber);
      if (index > -1) {
        this.subscribers.splice(index, 1);
      }
      subscriber.unsubscribe();
    });
  }

  raiseTabNav(event: TabNavEvent) {
    this.subscribers.forEach(subscriber => subscriber.next(event));
  }

  private navigating: Observable<string | false>;

  private subscribers: Subscriber<TabNavEvent>[] = [];

  /**
   * Tests an event to see if the event is a lazy load route configuration event.
   * @param event
   */
  private isRouteConfigurationEvent(event: Event): boolean {
    return event instanceof RouteConfigLoadStart || event instanceof RouteConfigLoadEnd;
  }
}

asapScheduler;
